import { Link } from 'react-router-dom';

// Unknown address (an old link, or a screen this user can't open).
export default function Placeholder({ title }) {
  return (
    <section className="card">
      <h1>{title}</h1>
      <p className="muted">This page doesn&apos;t exist or isn&apos;t available to you.</p>
      <div className="actions"><Link to="/" className="btn">Go to Home</Link></div>
    </section>
  );
}
